// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text__title[data-v-6aaa7702]{font-weight:700;font-size:26.6px;line-height:32px;color:#3b3e66}.text__description[data-v-6aaa7702]{font-weight:400;font-size:15.2px;line-height:22px;color:#3b3e66}", ""]);
// Exports
module.exports = exports;
